import * as React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { InformationGrid } from "@/components/dashboard/InformationGrid";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { InstrumentSearch, type InstrumentSummary } from "@/components/trading/InstrumentSearch";
import { WatchlistSection } from "@/components/trading/WatchlistSection";
import { QuoteCard } from "@/components/trading/QuoteCard";
import { OrderTicket, type OrderTicketValues } from "@/components/trading/OrderTicket";
import { OrderPreview } from "@/components/trading/OrderPreview";
import { RiskSummaryCard } from "@/components/trading/RiskSummaryCard";
import { MarketStatusCard } from "@/components/trading/MarketStatusCard";

export function TradingPage(): React.JSX.Element {
  const [selectedInstrument, setSelectedInstrument] = React.useState<InstrumentSummary | null>(null);
  const [watchlist, setWatchlist] = React.useState<InstrumentSummary[]>([]);
  const [preview, setPreview] = React.useState<OrderTicketValues | null>(null);

  const handleSelect = (instrument: InstrumentSummary) => {
    setSelectedInstrument(instrument);
    setWatchlist((prev) =>
      prev.some((i) => i.instrument_token === instrument.instrument_token)
        ? prev
        : [...prev, instrument],
    );
  };

  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Trading
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Preview-only trading workspace — order submission is disabled.
        </Typography>
      </Box>
      <Stack spacing={3}>
        <StatusCard title="Instrument Search">
          <InstrumentSearch onSelect={handleSelect} />
        </StatusCard>
        <WatchlistSection watchlist={watchlist} />
        <InformationGrid>
          <QuoteCard instrument={selectedInstrument} />
          <OrderTicket instrument={selectedInstrument} onPreview={setPreview} />
          <OrderPreview instrument={selectedInstrument} preview={preview} />
          <RiskSummaryCard instrument={selectedInstrument} preview={preview} />
          <MarketStatusCard />
        </InformationGrid>
      </Stack>
    </ResponsiveContainer>
  );
}
